import {createSvgIcon} from '../../../icons/utils'

export default createSvgIcon(
  <svg height="24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m12.008014,24.057907c6.627,0 11.999999,-5.372999 11.999999,-12.000001s-5.372999,-11.999991 -11.999999,-11.999991s-11.999999,5.372993 -11.999999,11.999991s5.373001,12.000001 11.999999,12.000001z"
      fill="#fff"
    />
    <path d="m12.008014,21.057907a9,9 0 1 0 0,-17.999995a9,9 0 0 0 0,17.999995z" fill="#F43" />
  </svg>,
  'MapGeolocationEn',
)
